import { render, staticRenderFns } from "./choosePerson.vue?vue&type=template&id=7192f8f5&scoped=true"
import script from "./choosePerson.vue?vue&type=script&lang=js"
export * from "./choosePerson.vue?vue&type=script&lang=js"
import style0 from "./choosePerson.vue?vue&type=style&index=0&id=7192f8f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7192f8f5",
  null
  
)

export default component.exports